import axiosInstance from "@/utils/axios";

export const notificationsApi = {
  subscribe: (payload) => axiosInstance.post("/api/notifications/subscribe", payload),
  unsubscribe: (payload, config) =>
    axiosInstance.post("/api/notifications/unsubscribe", payload, config),
  getMyDevices: () => axiosInstance.get("/api/notifications/my-devices"),
  acknowledgeDelivery: (payload) => axiosInstance.post("/api/notifications/delivery-ack", payload),
};
